import { Link } from 'react-router-dom';
import { ABERTURA, WHATSAPP_URL } from '../conteudo';

// Abertura curta: título, uma linha e os dois botões.
export default function Abertura() {
  return (
    <section className="app-entra">
      <h1 className="text-[26px] font-extrabold leading-tight text-foreground-950 md:text-[34px]">
        {ABERTURA.titulo}
      </h1>
      <p className="mt-3 text-[15px] leading-relaxed text-foreground-600 md:text-base">
        {ABERTURA.linha}
      </p>

      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <Link
          to="/criar"
          className="aperta flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] bg-primary-500 px-6 text-[15px] font-bold text-white transition-colors hover:bg-primary-600"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-add-line text-[20px]" aria-hidden />
          </span>
          {ABERTURA.botaoPrimario}
        </Link>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="aperta flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] border border-background-300 bg-background-50 px-6 text-[15px] font-bold text-foreground-800 transition-colors hover:bg-background-100 sm:w-auto"
        >
          <span className="flex h-5 w-5 items-center justify-center text-[#25D366]">
            <i className="ri-whatsapp-line text-[20px]" aria-hidden />
          </span>
          {ABERTURA.botaoWhatsapp}
        </a>
      </div>
    </section>
  );
}